/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, Skeleton, Typography2 } from '@coursera/cds-core';

const styles = {
  relatedArticlesCard: css`
    min-width: 304px;
    margin-bottom: 0;
  `,
  articleTitle: css`
    margin-bottom: var(--cds-spacing-50);
  `,
};

const RelatedArticlesCardPlaceholder = () => {
  return (
    <Grid css={styles.relatedArticlesCard} item xs={12} sm={6} md={4} component="li">
      <Typography2 component="p" css={styles.articleTitle} variant="bodyPrimary">
        <Skeleton variant="rect" />
      </Typography2>
      <Typography2 component="p" variant="bodySecondary">
        <Skeleton variant="rect" />
      </Typography2>
    </Grid>
  );
};

export default RelatedArticlesCardPlaceholder;
